export const revoke = {
  actions: {
    success: 'Operación exitosa',
  },
  title: 'Quitar acceso a catálogo',
  body: '¿Estás seguro de que querés quitarle el acceso a ',
  cancel: 'Cancelar',
  accept: 'Aceptar',
}

export const share = {
  actions: {
    success: 'Catálogo compartido',
  },
  title: 'Compartir catálogo',
  body: 'Ingresá el e-mail de la persona que quieras que vea tu catálogo.',
  labelEmail: 'E-mail',
  cancel: 'Cancelar',
  accept: 'Aceptar',
}

export const shared = {
  tabWithMe: 'Compartido conmigo',
  tabWithOthers: 'Compartido con otros',
}

export const withMe = {
  noCatalogsMessage: 'Nadie compartió su catálogo con vos',

}

export const withOthers = {
  share: 'Compartir',
  noCatalogsMessage: 'No compartiste tu catálogo con nadie',
}



// WEBPACK FOOTER //
// ./src/sections/shared/text.js